var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2583 4.6918C17.5833 5.0168 17.5833 5.5418 17.2583 5.8668L15.7333 7.3918L12.6083 4.2668L14.1333 2.7418C14.4583 2.4168 14.9833 2.4168 15.3083 2.7418L17.2583 4.6918ZM2.5 17.5001V14.3751L11.7167 5.15846L14.8417 8.28346L5.625 17.5001H2.5Z",
    fill: "#42526E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.d1d99c7c60525f18f5689ee54e006cd1.svg";
export { ForwardRef as ReactComponent };